import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill1 } from "@fortawesome/free-solid-svg-icons";
import './OrderComponents.css';
import placeholder from '../Icons/empty-placeholder.jpg';
import { ButtonBlue, ButtonLightGrey } from "../../HouseStyle/Components/Buttons";
import middleware from "../../Api/Middleware";
import { Link } from "react-router-dom";
import { formatCurrency } from "../../../utils";
import { generateCreditation } from "../../generatePDF/GenerateCreditation";

const CrediteringComponent = ({ productsToProcess = [], order, customer, prices, showPrice, setPaybackModalVisible, setPaybackAmount, setCreditationId, setSelectedCreditation }) => {
  const strip = (html) => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  const credit = async (creditation) => {
    if (!creditation) return;
    setPaybackAmount(creditation.restitution_total);
    setCreditationId(creditation.creditation_id);
    setSelectedCreditation && setSelectedCreditation(creditation);
    setPaybackModalVisible(true);
  }

  const creditations = Array.isArray(order.creditations) ? order.creditations : [];
  const isCreditationPaid = (creditation) => {
    if (!creditation) return false;
    if (creditation.payment_completed) return true;
    // Defensive: check for payment object and status
    if (creditation.payment && (creditation.payment.status === 'PAID' || creditation.payment.status === 'paid')) return true;
    // Sometimes payment_completed is not set, but payment.status is updated
    return false;
  }

  // Show all creditations, both paid and unpaid
  if (creditations.length === 0) return null;

  return creditations.map((e, index) => (
    <div key={index} className="whiteBox p-5 pt-4 mb-4 align-center">
      <div className="d-flex justify-content-between align-items-center pb-3 creditering-header">
        <h5 className="mb-0 fw-bold BlockTitle">Retour: #{order.order_number}</h5>
        <div className="d-flex flex-column ms-auto text-end">
          {e.payment_completed ? (
            <>
              <span className="fs-6 text-success fw-bold">
                Terugbetaald{e.updated_at ? ` op ${new Date(e.updated_at).toLocaleString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', ' om')}` : ''}
              </span>
              <span className="fs-6 text-success">
                Bedrag terugbetaald: {formatCurrency(e.restitution_total)}
              </span>
            </>
          ) : (
            <span className="fs-6 text-danger">
              Nog niet terugbetaald
            </span>
          )}
        </div>
      </div>

      <div className="row g-0">
        {e.creditation_products.length > 0 ? (
          <ul className='list-group list-group-flush'>
            {e.creditation_products.map((item, index) => {
              return (
                <li key={index} className='verwerk-list-group-item bottom-border-line d-flex justify-content-between align-items-center gap-3 pb-2 pt-2'>
                  <div className='d-flex flex-row gap-3 flex-grow-1'>
                    <div className='d-flex align-items-center'>
                      {/* Product image */}
                      <img
                        src={
                          item?.sold_product?.image?.path
                            ? middleware.defaults.imagesBaseURL + item?.sold_product.image?.path
                            : placeholder
                        }
                        className="rounded-circle p-2 me-3"
                        height={100}
                        width={100}
                        alt="placeholder..."
                      />

                      {/* Product info */}
                      <div className='d-flex flex-column justify-content-center align-items-start'>
                        <Link className='new-link-color' to={`/producten/bewerken/${item?.sold_product?.product_id}`} target="_blank" >
                          {item?.sold_product?.product_name}
                        </Link>
                        {item?.sold_product?.product_description &&
                          <p className='text-muted small mb-0'>{strip(item?.sold_product?.product_description)?.length < 100 ? strip(item?.sold_product?.product_description) : (strip(item?.sold_product?.product_description)?.slice(0, 100) ?? '') + "..."}</p>
                        }
                      </div>
                    </div>
                  </div>

                  {/* Product price info */}
                  <div className='d-flex align-items-center justify-content-end gap-3 gap-xxl-5 flex-grow-1'>
                    <span className='text-nowrap'>x{item.amount}</span>
                    <span className='fw-semibold'>{formatCurrency(-item.restitution)}</span>
                  </div>
                </li>
              )
            })}
          </ul>
        ) : (
          <div className="text-center p-3">
            <div className="text-center" role="status">
              <h5>There are no product to process...</h5>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex justify-content-between align-items-center pt-3">
        <h6 className="fw-bold">{e.creditation_reason || 'Geen reden opgegeven'}</h6>
        <div className="d-flex gap-3">
          <ButtonLightGrey text={"Print creditfactuur"} onClickFunction={() => generateCreditation([e.creditation_id])} />
          {!e.payment_completed ? <ButtonBlue text={"Terugbetalen"} onClickFunction={() => credit(e)} /> : null}
        </div>
      </div>
    </div>
  ))
};
export default React.memo(CrediteringComponent);